"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var json2typescript_1 = require("json2typescript");
var jsonConvert = new json2typescript_1.JsonConvert();
function createStringMapSerializers(jsonObjectClass) {
    var serialize = function (map) {
        return Object.entries(map).reduce(function (prev, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], value = _c[1];
            return (__assign(__assign({}, prev), (_b = {}, _b[key] = jsonConvert.serialize(value, jsonObjectClass), _b)));
        }, {});
    };
    var deserialize = function (mapData) {
        return Object.entries(mapData).reduce(function (prev, _a) {
            var _b;
            var _c = __read(_a, 2), key = _c[0], value = _c[1];
            return (__assign(__assign({}, prev), (_b = {}, _b[key] = jsonConvert.deserialize(value, jsonObjectClass), _b)));
        }, {});
    };
    return { serialize: serialize, deserialize: deserialize };
}
exports.default = createStringMapSerializers;
//# sourceMappingURL=createStringMapSerializers.js.map